module.exports = __webpack_public_path__ + "media/src/images/pdf_on-c02e541e71093ddcd53eb8142304e697.png";